(function() {

	function handleScroll(element, innerElement, navbarHeight, maxTranslate) {
		return function handleScrollReturned(e) {
			const translateX =
				Math.min(
					Math.max((window.pageYOffset || document.body.scrollTop) + navbarHeight - element.offsetTop, 0),
					maxTranslate
				);
			innerElement.setAttribute('style', `transform: translateX(-${translateX}px)`);
		}
	}

	function handleClickShowCollapsedText(e) {
		document.querySelector('.collections-collapsed-text').classList.add('collections-collapsed-text--visible');

		const $collectionsCollapsedText = $('.collections-collapsed-text');

		$collectionsCollapsedText.animate({
			height: $collectionsCollapsedText[0].scrollHeight,
		}, () => {
			$collectionsCollapsedText.removeAttr('style');

			Waypoint.refreshAll();
		});
	}

	window.addEventListener('load', () => {
		const element = document.querySelector('.collections-detail-slideshow');

		if (!element) return;

		const navbarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'), 10);
		const innerElement = element.firstElementChild;
		const maxTranslate = innerElement.scrollWidth - window.innerWidth;
		const height = innerElement.clientHeight + maxTranslate;

		// Nastav vysku
		element.setAttribute('style', `height: ${height}px`);

		// Zobraz slideshow
		innerElement.classList.remove('opacity-0');

		// Skryj loader
		innerElement.nextElementSibling.classList.add('d-none');

		const handleScrollFunc = handleScroll(element, innerElement, navbarHeight, maxTranslate);

		new Waypoint({
			element,
			offset: navbarHeight,
			handler: function(direction) {
				if (direction === 'down') {
					// aktivovat
					window.addEventListener('scroll', handleScrollFunc);
					innerElement.classList.add('position-fixed');

				} else {
					// deaktivovat
					window.removeEventListener('scroll', handleScrollFunc);
					innerElement.classList.remove('position-fixed');
				}
			}
		});

		new Waypoint({
			element,
			offset: 'bottom-in-view',
			handler: (direction) => {
				if (direction === 'down') {
					// deaktivovat
					window.removeEventListener('scroll', handleScrollFunc);
					innerElement.classList.remove('position-fixed');
					innerElement.classList.add('collections-detail-slideshow__inner--bottom');

				} else {
					// aktivovat
					window.addEventListener('scroll', handleScrollFunc)
					innerElement.classList.add('position-fixed');
					innerElement.classList.remove('collections-detail-slideshow__inner--bottom');
				}
			}
		});

	});

	$(function() {

		// Zobrazení celého textu v detailu kolekce
		const button = document.querySelector('.js-collections-collapsed-text-button');

		if (!button) return;

		button.addEventListener('click', handleClickShowCollapsedText);

	});

})();